module.exports = __webpack_public_path__ + "img/og-image_handbook_jp.e577a1b.jpg";